<template>
  <div class="monitor-list">
    <div class="listTop flex_bc">
      <div class="child1">排名</div>
      <div class="child2">位置</div>
      <div class="child3">当天实时人数</div>
      <div class="child4">当天累计人数</div>
    </div>
    <div class="scroll-box">
      <vue-seamless-scroll
        :data="list"
        class="seamless-warp"
        :class-option="classOption"
      >
        <ul>
          <li class="flex_bc" v-for="item in list" :key="item">
            <div class="child1">{{ item }}</div>
            <div class="child2">{{ item }}号停车场</div>
            <div class="child3">
              {{ (item * Math.random() * 1000).toFixed(0) }}
            </div>
            <div class="child4">
              {{ (item * Math.random() * 2000).toFixed(0) }}
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
  import vueSeamlessScroll from 'vue-seamless-scroll'

  export default {
    name: 'equipment-list',
    components: { vueSeamlessScroll },
    data() {
      return {
        input: '',
        list: [],
      }
    },
    computed: {
      classOption() {
        return {
          step: 0.2, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        }
      },
    },
    created() {
      this.list = Array.from({ length: 30 }, (v, i) => i + 1)
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .monitor-list {
    @mixin text_style {
      height: 45px;
      line-height: 45px;
      text-align: center;
    }

    .listTop {
      @include text_style;
      width: 100%;
      /*background: rgba(122, 255, 213, 0.1);*/
      color: #e6e6e6;
    }

    .scroll-box {
      height: 22vw;
      overflow: hidden;
    }

    ul {
      li {
        @include text_style;
        color: #fff;
      }
    }

    .listTop,
    li {
      div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .child1 {
      flex: 0 20%;
    }

    .child2 {
      flex: 0 20%;
    }

    .child3 {
      flex: 0 30%;
    }

    .child4 {
      flex: 0 30%;
    }
  }
</style>
